import { BBox } from 'geojson';
import { atom } from 'jotai';
import localforage from 'localforage';
import { IPosition } from '../../interfaces/map';
import { IRide, IRidePosition } from '../RidePlayer/types';
import { DEFAULT_ZOOM, MIN_POINTS_FOR_DISABLED_CLUSTER } from './GoogleMapLayer/constants';
import { localForageEffect } from '../../store/jotai/effects/localForageEffect';

const initIsRidePlayerOpen = () =>
  localforage.getItem<number | false>('isRidePlayerOpen').then((v) => v ?? false);

export const zoomAtom = atom<number>(DEFAULT_ZOOM);

export const isGoogleMapInitializedAtom = atom<boolean>(false);

export const autofocusAtom = atom<boolean>(true);
export const vehicleFocusAtom = atom<boolean>(false);
export const isRidePlayerMenuOpenAtom = atom<boolean>(false);

export const isRidePlayerOpenAtom = atom<number | false | Promise<number | false>>(
  initIsRidePlayerOpen()
);
export const isRidePlayerOpenLocalForageEffectAtom = localForageEffect(
  isRidePlayerOpenAtom,
  'isRidePlayerOpen'
);

export const isTrafficLayerOpenAtom = atom<boolean>(false);

export const isFullscreenAtom = atom<boolean>(false);

export const isAllSimpleWindowsOpenAtom = atom<boolean>(false);

export const filteredVehiclesAtom = atom<number[]>([]);

export const boundsAtom = atom<BBox | undefined>(undefined);

export const centerAtom = atom<IPosition>({
  lat: 48.75946,
  lng: 17.29349,
});

export const filterStringAtom = atom<string>('');

export const lastRideForSelectedVehicleAtom = atom<IRide | null>(null);

/** Latest position appended to the last-ride player (what the player currently shows as tip). */
export const currentRidePositionForSelectedVehicleAtom = atom<IRidePosition | null>(null);

/**
 * Every live GPS position received for the open last-ride player, in arrival order.
 * The player drains it into the ride, so bursts of socket messages are never coalesced.
 */
export const ridePositionQueueAtom = atom<IRidePosition[]>([]);

export const isStreetviewEnabledAtom = atom<boolean>(false);

export const minPointsAtom = atom<number>(MIN_POINTS_FOR_DISABLED_CLUSTER);

export const isRideLayerOpenAtom = atom<boolean>(false);

/**
 * How many open overlays (modals, dialogs) cover the map and must not let mouse gestures
 * reach it. A count rather than a flag, so closing one overlay cannot re-enable the map
 * while another is still open. Maintained by `useBlockMapGestures`.
 */
export const mapGestureBlockerCountAtom = atom<number>(0);
export const areMapGesturesBlockedAtom = atom((get) => get(mapGestureBlockerCountAtom) > 0);
